import React from 'react';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import type {UiCondition} from '../../../modules/ruleengine/types';
type Props = {
	condition: UiCondition;
};

const TriggerDurationDetails = ({condition}: Props) => {
	const duration = condition.duration;

	if (!duration || !duration.durationInMin) {
		return null;
	}

	const isHours = duration.durationInMin % 60 === 0;
	return (
		<div className="trigger-duration-details">
			<div className="trigger-detail-row">
				<label>
					<Trans i18nKey="ruleengine.triggerDetails.durationInMin">Duration:</Trans>
				</label>
				<div data-testid="trigger-details-duration-in-mins">
					{isHours ? (
						<>
							{duration.durationInMin / 60}{' '}
							<Trans i18nKey="ruleengine.triggerDetails.hoursShort">hour(s)</Trans>
						</>
					) : (
						<>
							{duration.durationInMin}{' '}
							<Trans i18nKey="ruleengine.triggerDetails.minutesShort">minute(s)</Trans>
						</>
					)}
				</div>
			</div>
		</div>
	);
};

export default TriggerDurationDetails;
